import {Field, PrimitiveObject} from "../../../Types";
import styled from "styled-components";
import React from "react";
import {LANG} from "../../CONSTANTS";
import {HeaderCell} from "../Table";
import {getColumnValue} from "../../functions";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearchengin} from "@fortawesome/free-brands-svg-icons";
import {fetchTableByQuery, setActiveTable, setTableFilters, switchToTablePK} from "../../../features/tableSlice";
import {nanoid} from "@reduxjs/toolkit";
import {useAppDispatch} from "../../../hooks";


interface PropsI {
    data: PrimitiveObject[],
    fields: Field[],
    searchByPk: (record: PrimitiveObject) => void
}

export default function RefTable({data, fields,searchByPk}: PropsI) {



    return <Container>
        <td colSpan={2}>
            <div className="ref-table-wrapper">
                <table>
                    <thead>
                    <tr>
                        {fields.map(field => <HeaderCell key={field.key} $align={field.headAlign || "center"}>
                            {field.shortHead?.[LANG] || field.title[LANG]}
                        </HeaderCell>)}
                    </tr>
                    </thead>
                    <tbody>
                    {data.map((r, ri) => <tr key={ri}>
                        {fields.map((field, fi) => <td key={fi} style={{position: fi === 0 ? "relative" : "unset"}}>
                            {getColumnValue(r[field.key], field, true, r)}
                            {fi === 0 && <button className="id-search btn-icon" onClick={() => searchByPk(r)}>
                                <FontAwesomeIcon icon={faSearchengin} title={"Шукати"} size={"lg"} className={'fa-color'}/>
                            </button>}
                        </td>)}
                    </tr>)}
                    </tbody>
                </table>
            </div>
        </td>
    </Container>
}

const Container = styled.tr`
    border-top: 2px solid var(--table-border-color);
    border-bottom: 2px solid var(--table-border-color);

    & .ref-table-wrapper {

        & table {
            width: 100%;

            & .id-search {
                position: absolute;
                left: calc(-1.25em - (var(--td-padding) * 3));
                top: 0;
                height: 100%;
                padding: var(--td-padding);
                rotate: y 180deg;
            }
        }
    }
`
